module.exports = __webpack_public_path__ + "static/media/report_accent_mobile.8658dac7.svg";